import { useTheme } from "../../../../theme";
import { calcORP } from "./orpLogic.js";

export default function WordDisplay({ word, phase, pal, orpMode, showGuides, fontSize }) {
  if (!word) return null;
  const t = useTheme();
  const orpIdx = calcORP(word, orpMode);
  const before = word.slice(0, orpIdx);
  const pivot = word[orpIdx] || "";
  const after = word.slice(orpIdx + 1);
  const active = phase === "streaming";

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      position: "relative", width: "100%", height: fontSize * 1.8,
      opacity: active ? 1 : phase === "done" ? 0.12 : 0.08,
      transition: "opacity 0.3s ease",
    }}>
      {showGuides && <>
        {/* Central fixation line — full height */}
        <div style={{
          position: "absolute", top: 0, bottom: 0, left: "50%", width: 1.5,
          background: active
            ? `linear-gradient(to bottom, transparent 0%, rgba(${pal.glow},0.25) 30%, rgba(${pal.glow},0.25) 70%, transparent 100%)`
            : `linear-gradient(to bottom, transparent 0%, ${t.borderSubtle} 30%, ${t.borderSubtle} 70%, transparent 100%)`,
          transition: "background 0.3s",
          transform: "translateX(-50%)",
        }} />
        {/* Top fixation marker — triangular notch */}
        <div style={{
          position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
          width: 0, height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderTop: `10px solid ${active ? `rgba(${pal.glow},0.5)` : t.borderStrong}`,
          transition: "border-top-color 0.3s",
          filter: active ? `drop-shadow(0 2px 6px rgba(${pal.glow},0.25))` : "none",
        }} />
        {/* Bottom fixation marker — triangular notch */}
        <div style={{
          position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)",
          width: 0, height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderBottom: `10px solid ${active ? `rgba(${pal.glow},0.5)` : t.borderStrong}`,
          transition: "border-bottom-color 0.3s",
          filter: active ? `drop-shadow(0 -2px 6px rgba(${pal.glow},0.25))` : "none",
        }} />
        {/* Left and right horizontal tick marks at midline */}
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(calc(-50% - 28px), -50%)",
          width: 18, height: 2, borderRadius: 1,
          background: active ? `rgba(${pal.glow},0.3)` : t.borderSubtle,
          transition: "background 0.3s",
        }} />
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(calc(-50% + 28px), -50%)",
          width: 18, height: 2, borderRadius: 1,
          background: active ? `rgba(${pal.glow},0.3)` : t.borderSubtle,
          transition: "background 0.3s",
        }} />
      </>}
      <div style={{
        display: "flex", alignItems: "baseline",
        fontFamily: "'DM Mono', monospace",
        fontSize, fontWeight: 400, letterSpacing: "0.04em", lineHeight: 1,
      }}>
        <span style={{
          color: t.mode === "dark" ? `rgba(255,255,255,${active ? 0.55 : 0.2})` : `rgba(0,0,0,${active ? 0.65 : 0.25})`,
          textAlign: "right",
          minWidth: `${Math.max(orpIdx, 0) * 0.62}em`, display: "inline-block",
          transition: "color 0.2s",
        }}>{before}</span>
        <span style={{
          color: pal.pivot, fontWeight: 600,
          textShadow: active ? `0 0 18px rgba(${pal.glow},0.35)` : "none",
          transition: "color 0.3s, text-shadow 0.3s",
        }}>{pivot}</span>
        <span style={{
          color: t.mode === "dark" ? `rgba(255,255,255,${active ? 0.55 : 0.2})` : `rgba(0,0,0,${active ? 0.65 : 0.25})`,
          transition: "color 0.2s",
        }}>{after}</span>
      </div>
    </div>
  );
}
